export default __webpack_public_path__ + "static/affinity-a52d524ec182b2315c4a2e81b57fbd3c.png";